import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { WarrantyInfoService } from 'src/app/services/feature/warrantyInfo/warranty-info.service';
@Component({
  selector: 'app-warranty-tabs',
  templateUrl: './warranty-tabs.component.html',
  styleUrls: ['./warranty-tabs.component.scss'],
  standalone: false
})
export class WarrantyTabsComponent implements OnDestroy {
  oneAtATime: boolean = true;
  isMobile: boolean = false;
  isFirstOpen: boolean = true;
  selectedIndex: boolean[] = new Array(6).fill(false);
  apidata$: Observable<any> = this.warrantyInfoService.getApi();
  selectedWarranty: any;
  subscription = new Subscription();
  constructor(
    public breakpointObserver: BreakpointObserver,
    private warrantyInfoService: WarrantyInfoService,
    private cdr: ChangeDetectorRef
  ) {
    this.subscription.add(this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
      this.isMobile = result.matches;
    }));
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();

  }

  log(event: any, index) {
    this.switchAtIndex(this.selectedIndex, index);
  }

  switchAtIndex(array: boolean[], index: number): void {
    if (index >= 0 && index < array.length) {
      array[index] = !array[index];
      this.cdr.detectChanges();
    } else {
      console.error('Index out of bounds.');
    }
  }

  getSelectedEligibilityResult(event) {
    this.selectedWarranty = event;
    this.cdr.detectChanges();
  }
}
